import { transformEditDataControl } from 'shell/utils/consult-person/response-transformer/edit-data-control';
import { transformPerson } from 'shell/utils/consult-person/response-transformer/person/person';
import { HttpResponse } from 'shell/models/http-response';
import { ResponseAnprData } from 'shell/models/person';
import { transformIdentityCard } from 'shell/utils/consult-person/response-transformer/documents/identity-card';
import { AxiosResponse } from 'axios';
import { RegistationIdCardFormVM } from 'front-office/view-models/registration-id-card';

export const emptyIdentityCard = {
  number: '',
  type: '',
  expatriationBan: false,
  releaseDate: null,
  expirationDate: null,
  cancellationDate: null,
  municipality: null,
  consulateCode: '',
  isConsulateRelease: false,
  toAccount: false,
  releaseMode: '',
  typePayment: '',
  location: '',
  province: '',
};

export const transformResponse = (
  response: AxiosResponse<HttpResponse<ResponseAnprData>>
): RegistationIdCardFormVM => {
  const responseToTransform = response.data.payload?.risposta3002OK || {};

  const person = responseToTransform.listaSoggetti?.datiSoggetto[0] || {};

  const headingResponse = responseToTransform.testataRisposta;

  const personStep = transformPerson(person);
  const editDataControl = transformEditDataControl(headingResponse);
  const identityCard = transformIdentityCard(person);

  return {
    person: personStep,
    identityCard: { ...emptyIdentityCard, ...identityCard } || emptyIdentityCard,
    editDataControl,
    dataRilascio3002: person.cartaIdentita?.dataRilascio,
    dataScandenza3002: person.cartaIdentita?.dataScadenza,
    generality: person.generalita,
  };
};
